import { render, staticRenderFns } from "./RsaGestioneOspitiList.vue?vue&type=template&id=c63a1a84"
import script from "./RsaGestioneOspitiList.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports